module.exports = "<!--component html goes here -->\r\n <ng2-toasty [position]=\"'center-center'\"></ng2-toasty>\r\n "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ixsloader/ixsloader.component.html
// module id = 1200
// module chunks = 322